module.exports = __webpack_public_path__ + "img/ma1.d0aeac84.jpeg";